import React, { useEffect, useState } from 'react';
import PodcastHeader from '../components/PodcastEditor/PodcastHeader';
import Banner from '../components/PodcastEditor/Banner';
import DialogueCard from '../components/PodcastEditor/DialogueCard';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useNavigate } from 'react-router-dom';
import GeneratePodcast from '../modals/GeneratePodcast';
import DiscardPodcast from '../modals/DiscardPodcast';
import toast from 'react-hot-toast';

const PodcastEditor = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true);
  const navigate = useNavigate();
  const { data } = useSelector((state: RootState) => state.podcastRes);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [restoredState, setRestoredState] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Check if this is a restored state and show a notification
    const savedPodcast = localStorage.getItem('pending_podcast');
    if (savedPodcast && isAuthenticated && data.dialogues.length > 0 && !restoredState) {
      toast.success('Your podcast has been restored');
      setRestoredState(true);
      // Navigate to the podcast editor page
      navigate('/ai-podcast-generator/view-podcast', { replace: true });
    } else if (data.dialogues.length === 0) {
      navigate('/ai-podcast-generator/get-started');
    }
  }, [data.dialogues.length, navigate, isAuthenticated, restoredState]);

  if (data.dialogues.length === 0) return null;

  return (
    <div className="flex items-stretch gap-2 overflow-auto w-full h-full">
      <div className="w-full rounded-lg">
        <div className="rounded-lg flex flex-col">
          {/* header */}
          <div className="">
            <PodcastHeader isGenerated={false} />
          </div>
          
          {/* banner */}
          {showBanner && (
            <div className="bg-background-main h-[80px] sm:h-10">
              <Banner setShowBanner={setShowBanner} />
            </div>
          )}
          {/* body - dialogue cards*/}
          <div className="sm:px-20 flex-1 sm:mt-0 mt-10 px-5 pb-24">
            <div className="flex flex-col max-w-[1200px] mx-auto items-center justify-center gap-8 sm:px-20 sm:py-20">
              {data.dialogues.map((dialogue, index) => {
                return (
                  <DialogueCard
                    {...dialogue}
                    key={`${dialogue.preview_url}-${index}`}
                    index={index}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center gap-2 md:hidden bg-background w-full rounded-t-md p-[10px] fixed z-[100] bottom-0 right-0">
        <DiscardPodcast />
        <GeneratePodcast />
      </div>
    </div>
  );
};

export default PodcastEditor;
